export const getShouldShowAddCompanyOption = (
  filteredOptions: unknown[]
): boolean => filteredOptions.length === 0;
